<template>
  <div id="app">
    <nav id="nav nav-unfocused" @click="unfocusedNavAtHome()">
      <img src="./assets/img/belasia-logo.png" alt="" class="belasia-logo">
      <br id='logo-break'>
      <router-link to="/">Home</router-link> |
      <router-link to="/partners">Our Partners</router-link> |
      <b-dropdown id="dropdown-1" text="Products" class="m-md-2 nav-dropdown nav-dropdown-active">
        <b-dropdown-item class="nav-dropdown-item"><router-link to="/products/diagnostic">Diagnostic</router-link></b-dropdown-item>
        <b-dropdown-item class="nav-dropdown-item"><router-link to="/products/wound-care">Wound Care</router-link></b-dropdown-item>
      </b-dropdown>
    </nav>
    <div id="nav-ghost"></div>
    <router-view/>
    <bottom/>
  </div>
</template>


<script>
import bottom from '@/components/Bottom.vue'
var $ = require( "jquery" );

export default {
  components: {
    bottom
  },
  methods: {
    focusNav(){
      $("nav").addClass("nav-focused");
      $("nav").removeClass("nav-unfocused");
    },
    unfocusNav(){
      $("nav").addClass("nav-unfocused");
      $("nav").removeClass("nav-focused");
    },
    throttleFunc() {
      if (this.$route.name == 'Home'){
        if (window.scrollY > 600){
          this.focusNav()
        } else{
          this.unfocusNav()
        }
      } else {
        if (window.scrollY > 180){
          this.focusNav()
        } else{
          this.unfocusNav()
        }
      }
    },
    unfocusedNavAtHome(){
      $("#nav-ghost").css("height", "0px")
        this.unfocusNav()
      // if(this.$route.name == 'Home'){
      //   $("#nav-ghost").css("height", "0px")
      //   this.unfocusNav()
      // }else{
      //   $("#nav-ghost").css("height", $("nav").css("height"))
      //   this.focusNav()
      // }
    }
  },
  data: function() {
    return {
      lastCall: 0,
      interval: 250
    }
  },
  created() {
    window.addEventListener('scroll', this.throttle);
  },
  mounted(){
    this.unfocusedNavAtHome()
  },
  destroyed() {
    window.removeEventListener('scroll', this.throttle);
  },
  updated(){
    $('.nav-dropdown').removeClass('nav-dropdown-active')
  }
}
</script>
